<button id="video-guide-btn" class="video-guide" #fileInput data-bs-toggle="modal" data-bs-target="#myModal"
  [hidden]="isIconHide" (click)="IsvideoActive(true);">
  <img [src]="icons.PLAY_FILLED" alt="Video" />
  {{ 'Video Guide' | translate }}
</button>

<div class="clear"></div>

<div #modal (click)="afterHidden(false)" class="modal fade z-99999 blured-overLay" id="myModal" role="dialog"
  data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog" role="document" style="max-width: 970px;  margin: 1.75rem auto;">
    <div class="modal-content">
      <div class="modal-header">
        <button style="background-color: transparent !important" type="button" class="close" data-bs-dismiss="modal"
          aria-label="Close" (click)="close(false);"><span aria-hidden="true"
            class="video-close">&times;</span></button>
      </div>
      <div class="modal-body">
        @if(showLoading){<div class="show-iframe-loader">
        </div>}
        <div [class.d-none]="showLoading" style="background:white;width:100%;margin:auto;"><iframe [src]='VideoUrl'
            referrerpolicy="strict-origin-when-cross-origin"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            (load)="onLoad()" width="100%" height="450px" frameborder="0" webkitallowfullscreen mozallowfullscreen
            allowfullscreen [className]="this.setClass"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>